import type { Edge, Resource } from '@/db/types'
import { compact, invalid } from '@/kinds/kind'
import { formatTime } from '@/lib/time'
import { pageDisplayName, type PageSpec, type PageStatus } from './schema'

export type PageResource = Resource<PageSpec, PageStatus>

export const defaults = (spec: Partial<PageSpec>): PageSpec => ({
  title: '',
  blocks: [],
  text: '',
  pinned: false,
  ...spec,
})

export const validate = (_r: PageResource, edgesFrom: Edge[]): string[] =>
  edgesFrom.filter((e) => e.relation === 'belongs_to' && !e.deleted_at).length > 1
    ? ['a page belongs to at most one thing']
    : []

export const initialStatus = (r: PageResource): PageStatus =>
  compact({ last_touched: formatTime(new Date(r.created_at)) })

export const displayName = (r: PageResource) => pageDisplayName(r.spec)

export const afterPatch = (r: PageResource, at: string): PageResource => ({
  ...r,
  status: compact({ ...r.status, last_touched: formatTime(new Date(at)) }),
})

export const apply = (_r: PageResource, action: string): PageResource => {
  throw invalid(`Page has no action ${action}`)
}
